<template>
  <v-card>
    <v-card-title class="grey">
      <h3 class="headline white--text">Calcite Saturation Index (CSI)</h3>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs6>
          <h4 class="subheading">
            Tested:
            {{
              (csi.tested = calculateCSI(
                borate.tested,
                ch.tested,
                cya.tested,
                ph.tested,
                salt.tested,
                ta.tested
              ))
            }}
          </h4>
        </v-flex>
        <v-flex xs6>
          <h4 class="subheading">
            Goal:
            {{
              (csi.goal = calculateCSI(
                borate.goal,
                ch.goal,
                cya.goal,
                ph.goal,
                salt.goal,
                ta.goal
              ))
            }}
          </h4>
        </v-flex>
        <v-flex xs12>
          <h4 class="subheading mt-3">
            <strong>CONCLUSION:</strong>
          </h4>
          <p>
            <span v-if="csi.tested <= -0.6">Corrosion of plaster likely</span>
            <span v-else-if="csi.tested <= -0.3"
              >Potential to become corrosive to plaster</span
            >
            <span v-else-if="csi.tested < 0.3">Balanced</span>
            <span v-else-if="csi.tested < 0.6"
              >Potential to become scaling</span
            >
            <span v-else-if="csi.tested >= 0.3">Scaling likely</span>
            <span v-else>Invalid Inputs</span>
          </p>
        </v-flex>
      </v-layout>
      <a
        target="_blank"
        href="https://www.poolcalculator.com/pool-chemistry/calcium-saturation-index/"
        >Learn more about Calcite Saturation Index »</a
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CSI",
  data() {
    return {
      csi: {
        tested: "",
        goal: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      borate: "borate/getBorate",
      ch: "ch/getCH",
      cya: "cya/getCYA",
      ph: "ph/getPH",
      salt: "salt/getSalt",
      ta: "ta/getTA",
      settings: "settings/getSettings",
    }),
  },
  methods: {
    calculateCSI(borate, ch, cya, ph, salt, ta) {
      let temp = this.settings.temperature;
      if (this.settings.unitType != "Metric")
        temp = ((this.settings.temperature - 32) * 5) / 9;
      let carbAlk =
        ta -
        (0.38772 * cya) / (1 + Math.pow(10, 6.83 - ph)) -
        (4.63 * borate) / (1 + Math.pow(10, 9.11 - ph));
      let extraNaCl = salt - 1.1678 * ch > 0 ? salt - 1.1678 * ch : 0;
      let ionic = (1.5 * ch + 1 * ta) / 50045 + extraNaCl / 58440;
      let csi =
        ph -
        11.677 +
        Math.log(ch) / Math.LN10 +
        Math.log(carbAlk) / Math.LN10 -
        (2.56 * Math.sqrt(ionic)) / (1 + 1.65 * Math.sqrt(ionic)) -
        1412.5 / (temp + 273.15) +
        4.7375;
      return Math.floor(csi * 100 + 0.5) / 100;
    },
  },
};
</script>
